// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-module__contentRow--v7OwP {
    display: flex;
    gap: 40px;
}
.components-module__contentRow--v7OwP:not(:first-child) {
    margin-top: 20px; 
}
.components-module__contentColumn--yfXUp {
    display: flex;
    flex-direction: column;
    width: 280px;
}

.components-module__contentColumn--yfXUp > span {
    color: #6F879C;
    font-size: 16px;
    border-bottom: 1px solid #6f879c4b;
}

.components-module__contentColumn--yfXUp > p {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 18px;
}

.components-module__rightBox--IAVQF {
    width: 50%;
    border-right: 1px solid #6f879c4b;
}
.components-module__leftBox--d4xIb {
    width: 50%;
}

.components-module__shadowBox--v3CW0 {
    display: flex;
    margin-top: 30px;
    padding: 15px 20px;
    border-radius: 14px;
    gap: 15px;
    height: 45vh;
    background-color: white;
    overflow: hidden;
}

.components-module__icon--jI24C>svg {
    font-size: 16px;
    display: flex
}

.components-module__icon--jI24C {
    display: flex;
    align-items: center;
    gap: 5px;
}
.components-module__title--gDy6Q {
    color: #6F879C;
    font-size: 20px;
    font-weight: 400;
}
.components-module__headerPaymentSchedule--JQJvM {
    display: flex;
    flex-direction: row;
    text-decoration: none;
    color: #6F879C;
    font-size: 16px;
    font-weight: 400;
    border-bottom: 1px solid #6f879c4b;
    min-width: 800px;
}

.components-module__headerItem--ZBfKJ {
    width: 25%;
    padding: 8px 0;
    text-align: center;
}

.components-module__border--L_5KE {
    border-right: 1px solid #6f879c4b;
}
.components-module__listPaymentSchedule--boSBl {
    display: flex;
    flex-direction: column;
    padding: 0 5px;
    overflow-x: auto;
    width: 1000px;
}

.components-module__contentItemPaymentSchedule--UQImC {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 16px;
    display: flex;
    min-width: 800px;
    
}

.components-module__contentItem--AQNpe {
    width: 25%;
    padding: 8px 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.components-module__contentItemPaymentSchedule--UQImC>div>p {
    display: flex;
    align-content: center;
    align-items: center;
    font-size: 17px;
    margin: 0;
    justify-content: center;
}

.components-module__contentItemPaymentSchedule--UQImC>div>p>svg {
    font-size: 17px;
    margin-left: 4px;
}

.components-module__contentCurator--m2Cp_ {
    display: flex;
    flex-direction: column;
    
}
.components-module__contentCurator--m2Cp_ > h3 {
    color: #6F879C;
    font-size: 16px;
    margin-top: 0;
}

.components-module__curatorInfo--GCdAM {
    display: flex;
    align-items: center;
    gap: 20px;
    height: 45px;
}

.components-module__contentCurator--m2Cp_:not(:first-child) {
    margin-top: 20px; 
}

.components-module__contentCurator--m2Cp_:not(:last-child) {
    border-bottom: 1px solid #6f879c4b;
}

.components-module__curatorInfo--GCdAM > p {
    font-weight: 500;
    color: #516372;
    font-size: 18px;
}
.components-module__curatorInfo--GCdAM > span {
    color: #6F879C;
    font-size: 16px;
}

.components-module__btnBoxDown--IM55X {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.components-module__listBox--qB1Bx {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    height: 65vh;

}

.components-module__boxContentItemHeader--vvpZb {
    display: flex;
    flex-direction: row;
    gap: 15px;
    border-bottom: 1px solid #eee;
    text-decoration: none;
    color: black;
    padding: 0 5px;
    background-color: #E0E4E8;
    padding: 0 15px;
    border-top-left-radius: 14px;
    /* Скругление верхнего левого угла */
    border-top-right-radius: 14px;
    /* Скругление верхнего правого угла */
}

.components-module__boxContentItemHeader--vvpZb>div {
    width: 25%;
    text-align: center;
    color: #6F879C;
    font-weight: 500;
}

.components-module__boxContentItem--DggZz>div {
    width: 25%;
    text-align: center;
    color: #6F879C;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.components-module__boxContentItem--DggZz>div>p {
    display: flex;
    align-items: center;
    justify-content: center;
}
.components-module__containerLoader--RBpeC {
    position: fixed;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgb(44 44 45 / 33%);
    -webkit-tap-highlight-color: transparent;
    z-index: 1;
}

.components-module__boxContentItem--DggZz {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #eee;
    text-decoration: none;
    padding: 0 5px;
    background-color: white;
    max-height: 50px;
}
.components-module__btnBox--BtCBA {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
}


.components-module__updateBtnBox--VkP2N {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.components-module__errorText--Gh_nl {
    margin-top: 16px;
    color: red;
    font-size: 20px;
    text-align: center;
}
.components-module__shadowBoxSpecialProgram--CpXKN {
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/features/contract-page/ui/components.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iCAAiC;AACrC;AACA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;AACA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;IAC/B,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,MAAM;IACN,OAAO;IACP,qCAAqC;IACrC,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;AACA;IAEI,sBAAsB;AAC1B","sourcesContent":[".contentRow {\r\n    display: flex;\r\n    gap: 40px;\r\n}\r\n.contentRow:not(:first-child) {\r\n    margin-top: 20px; \r\n}\r\n.contentColumn {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 280px;\r\n}\r\n\r\n.contentColumn > span {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.contentColumn > p {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.rightBox {\r\n    width: 50%;\r\n    border-right: 1px solid #6f879c4b;\r\n}\r\n.leftBox {\r\n    width: 50%;\r\n}\r\n\r\n.shadowBox {\r\n    display: flex;\r\n    margin-top: 30px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    gap: 15px;\r\n    height: 45vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.icon>svg {\r\n    font-size: 16px;\r\n    display: flex\r\n}\r\n\r\n.icon {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n}\r\n.headerPaymentSchedule {\r\n    display: flex;\r\n    flex-direction: row;\r\n    text-decoration: none;\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    border-bottom: 1px solid #6f879c4b;\r\n    min-width: 800px;\r\n}\r\n\r\n.headerItem {\r\n    width: 25%;\r\n    padding: 8px 0;\r\n    text-align: center;\r\n}\r\n\r\n.border {\r\n    border-right: 1px solid #6f879c4b;\r\n}\r\n.listPaymentSchedule {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 0 5px;\r\n    overflow-x: auto;\r\n    width: 1000px;\r\n}\r\n\r\n.contentItemPaymentSchedule {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 16px;\r\n    display: flex;\r\n    min-width: 800px;\r\n    \r\n}\r\n\r\n.contentItem {\r\n    width: 25%;\r\n    padding: 8px 0;\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.contentItemPaymentSchedule>div>p {\r\n    display: flex;\r\n    align-content: center;\r\n    align-items: center;\r\n    font-size: 17px;\r\n    margin: 0;\r\n    justify-content: center;\r\n}\r\n\r\n.contentItemPaymentSchedule>div>p>svg {\r\n    font-size: 17px;\r\n    margin-left: 4px;\r\n}\r\n\r\n.contentCurator {\r\n    display: flex;\r\n    flex-direction: column;\r\n    \r\n}\r\n.contentCurator > h3 {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n    margin-top: 0;\r\n}\r\n\r\n.curatorInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    height: 45px;\r\n}\r\n\r\n.contentCurator:not(:first-child) {\r\n    margin-top: 20px; \r\n}\r\n\r\n.contentCurator:not(:last-child) {\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.curatorInfo > p {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    font-size: 18px;\r\n}\r\n.curatorInfo > span {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n}\r\n\r\n.btnBoxDown {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n}\r\n\r\n.listBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 5px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    height: 65vh;\r\n\r\n}\r\n\r\n.boxContentItemHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 15px;\r\n    border-bottom: 1px solid #eee;\r\n    text-decoration: none;\r\n    color: black;\r\n    padding: 0 5px;\r\n    background-color: #E0E4E8;\r\n    padding: 0 15px;\r\n    border-top-left-radius: 14px;\r\n    /* Скругление верхнего левого угла */\r\n    border-top-right-radius: 14px;\r\n    /* Скругление верхнего правого угла */\r\n}\r\n\r\n.boxContentItemHeader>div {\r\n    width: 25%;\r\n    text-align: center;\r\n    color: #6F879C;\r\n    font-weight: 500;\r\n}\r\n\r\n.boxContentItem>div {\r\n    width: 25%;\r\n    text-align: center;\r\n    color: #6F879C;\r\n    font-size: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.boxContentItem>div>p {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.containerLoader {\r\n    position: fixed;\r\n    display: flex;\r\n    -webkit-align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    -webkit-justify-content: center;\r\n    justify-content: center;\r\n    right: 0;\r\n    bottom: 0;\r\n    top: 0;\r\n    left: 0;\r\n    background-color: rgb(44 44 45 / 33%);\r\n    -webkit-tap-highlight-color: transparent;\r\n    z-index: 1;\r\n}\r\n\r\n.boxContentItem {\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-bottom: 1px solid #eee;\r\n    text-decoration: none;\r\n    padding: 0 5px;\r\n    background-color: white;\r\n    max-height: 50px;\r\n}\r\n.btnBox {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n\r\n.updateBtnBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n}\r\n.errorText {\r\n    margin-top: 16px;\r\n    color: red;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n.shadowBoxSpecialProgram {\r\n    composes: shadowBox;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentRow": `components-module__contentRow--v7OwP`,
	"contentColumn": `components-module__contentColumn--yfXUp`,
	"rightBox": `components-module__rightBox--IAVQF`,
	"leftBox": `components-module__leftBox--d4xIb`,
	"shadowBox": `components-module__shadowBox--v3CW0`,
	"icon": `components-module__icon--jI24C`,
	"title": `components-module__title--gDy6Q`,
	"headerPaymentSchedule": `components-module__headerPaymentSchedule--JQJvM`,
	"headerItem": `components-module__headerItem--ZBfKJ`,
	"border": `components-module__border--L_5KE`,
	"listPaymentSchedule": `components-module__listPaymentSchedule--boSBl`,
	"contentItemPaymentSchedule": `components-module__contentItemPaymentSchedule--UQImC`,
	"contentItem": `components-module__contentItem--AQNpe`,
	"contentCurator": `components-module__contentCurator--m2Cp_`,
	"curatorInfo": `components-module__curatorInfo--GCdAM`,
	"btnBoxDown": `components-module__btnBoxDown--IM55X`,
	"listBox": `components-module__listBox--qB1Bx`,
	"boxContentItemHeader": `components-module__boxContentItemHeader--vvpZb`,
	"boxContentItem": `components-module__boxContentItem--DggZz`,
	"containerLoader": `components-module__containerLoader--RBpeC`,
	"btnBox": `components-module__btnBox--BtCBA`,
	"updateBtnBox": `components-module__updateBtnBox--VkP2N`,
	"errorText": `components-module__errorText--Gh_nl`,
	"shadowBoxSpecialProgram": `components-module__shadowBoxSpecialProgram--CpXKN components-module__shadowBox--v3CW0`
};
export default ___CSS_LOADER_EXPORT___;
